export default "__VITE_ASSET__akTmsy8O__"